"use strict";
'use strict';

var tag = require('./tag.cjs');



exports.CloseTrigger = tag.TagCloseTrigger;
exports.EndElement = tag.TagEndElement;
exports.Label = tag.TagLabel;
exports.Root = tag.TagRoot;
exports.RootPropsProvider = tag.TagRootPropsProvider;
exports.StartElement = tag.TagStartElement;
